import { useTrackingConsent } from "@/hooks/shared/tracking-consent/useTrackingConsent";
import { PostHogProvider, PostHogErrorBoundary } from "posthog-js/react";
import { memo } from "react";
import { GoogleAnalyticsProvider } from "./GoogleAnalyticsProvider";
import { GoogleTagManagerProvider } from "./GoogleTagManagerProvider";
import { POSTHOG_PROVIDER_OPTIONS } from "@/config/posthog.config";

export const TrackingProvider = memo(function Tracking({ children }: { children: React.ReactNode }) {
    const { canTrack } = useTrackingConsent();

    return (
        <>
            {/* Only wrap trackers with consent */}
            {canTrack ? (
                <PostHogProvider {...POSTHOG_PROVIDER_OPTIONS}>
                    <PostHogErrorBoundary>
                        <GoogleTagManagerProvider>
                            <GoogleAnalyticsProvider>{children}</GoogleAnalyticsProvider>
                        </GoogleTagManagerProvider>
                    </PostHogErrorBoundary>
                </PostHogProvider>
            ) : (
                <PostHogProvider {...POSTHOG_PROVIDER_OPTIONS}>
                    <PostHogErrorBoundary>{children}</PostHogErrorBoundary>
                </PostHogProvider>
            )}
        </>
    );
});

TrackingProvider.displayName = "TrackingProvider";
